import { Pagination as SharedPagination } from '@cinch-nx/shared-ui'
import { useRouter } from 'next/router'

interface ArticlesPaginationHubProps {
  path: string
  currentPage: number
  total: number
  resultsPerPage?: number
}

export const Pagination: React.FC<ArticlesPaginationHubProps> = ({
  path,
  currentPage,
  resultsPerPage = 10,
  total,
}) => {
  const { isFallback } = useRouter()

  if (isFallback) {
    return null
  }

  return (
    <SharedPagination
      totalItemsCount={total}
      activePage={currentPage}
      itemsCountPerPage={resultsPerPage}
      sourcePage={path}
      enabledLinks={true}
    />
  )
}
